import { createAction, props } from '@ngrx/store';
import { CreateProductRequest, Product, UpdateProductRequest } from '@models/product.model';

export enum ProductActions {
  GET_PRODUCTS = '[Products] Get products',
  GET_PRODUCTS_SUCCESS = '[Products] Products fetched',
  GET_PRODUCTS_FAILED = '[Products] Cannot fetch products',
  UPDATE_PRODUCT = '[Products] Update product',
  UPDATE_PRODUCT_SUCCESS = '[Products] Product updated',
  UPDATE_PRODUCT_FAILED = '[Products] Cannot update product',
  CREATE_PRODUCT = '[Products] Create product',
  CREATE_PRODUCT_SUCCESS = '[Products] Product created',
  CREATE_PRODUCT_FAILED = '[Products] Cannot create product',
  DELETE_PRODUCT = '[Products] Delete product',
  DELETE_PRODUCT_SUCCESS = '[Products] Product deleted',
  DELETE_PRODUCT_FAILED = '[Products] Cannot delete product',
  SET_PRODUCT_DETAIL = '[Products] Set product detail',
}

export const fetchProducts = createAction(ProductActions.GET_PRODUCTS, props<{ payload: string }>());
export const productsFetched = createAction(ProductActions.GET_PRODUCTS_SUCCESS, props<{
  payload: Product[]
}>());
export const cannotFetchProducts = createAction(ProductActions.GET_PRODUCTS_FAILED, props<{ error: string }>());

export const updateProduct = createAction(ProductActions.UPDATE_PRODUCT, props<{
  webshopId: string,
  payload: UpdateProductRequest
}>());
export const productUpdated = createAction(ProductActions.UPDATE_PRODUCT_SUCCESS, props<{ payload: Product }>());
export const cannotUpdateProduct = createAction(ProductActions.UPDATE_PRODUCT_FAILED, props<{ error: string }>());

export const createProduct = createAction(ProductActions.CREATE_PRODUCT, props<{
  webshopId: string,
  payload: CreateProductRequest
}>());
export const productCreated = createAction(ProductActions.CREATE_PRODUCT_SUCCESS, props<{ payload: Product }>());
export const cannotCreateProduct = createAction(ProductActions.CREATE_PRODUCT_FAILED, props<{ error: string }>());

export const deleteProduct = createAction(ProductActions.DELETE_PRODUCT, props<{
  webshopId: string,
  productId: string
}>());
export const productDeleted = createAction(ProductActions.DELETE_PRODUCT_SUCCESS, props<{ payload: string }>());
export const cannotDeleteProduct = createAction(ProductActions.DELETE_PRODUCT_FAILED, props<{ error: string }>());

export const setProductDetail = createAction(ProductActions.SET_PRODUCT_DETAIL, props<{ payload?: string }>());
